angular.module('PatientApp').controller('PaymentAgreementReceiptCtrl', function($rootScope, $q, $scope, $state, $filter, $window, $log, _, PaymentsService, CardService, ContextHelperService, MoneyUtilsService, BillsService, ProvidersService) {

    var _paymentAgreementId = $state.params.paymentAgreementId,
        _paymentAgreement,
        _forceProvidersReload,
        _setupUIVariables;

    if (!_paymentAgreementId) {
        $state.go('app.dashboard');
    }

    $scope.translateData = {};

    _forceProvidersReload = function() {
        ProvidersService.flushProviders();
    };

    _setupUIVariables = function() {
        var formattedOrigAmount = $filter('currency')(_paymentAgreement.amount);

        $scope.summationTotalFormatted = formattedOrigAmount;
        $scope.translateData.date = $filter('dateFormat')(_paymentAgreement.dateCreated, 'MM/dd/yy');
        $scope.paymentAgreementState = $filter('translate')('labels.futurePayment');
        $scope.amountStatus = $filter('translate')('labels.argAuthorized', { amount: formattedOrigAmount });
        $scope.callOutAmountStatus = $filter('translate')('receipt.argAuthorizedCallOut', { amount: formattedOrigAmount });

        // set up lineItems for table summary
        $scope.lineItems = [];

        // payment agreement
        $scope.lineItems.push({
            date: _paymentAgreement.dateCreated,
            friendlyDialog: $filter('translate')('payment.friendlyType.agreement'),
            amountDialog: formattedOrigAmount
        });

        if (_paymentAgreement.dateCanceled) {
            $scope.paymentAgreementState = $filter('translate')('labels.canceledPayment');
            $scope.amountStatus = $filter('translate')('labels.argCanceled', { amount: formattedOrigAmount });
            $scope.callOutAmountStatus = $filter('translate')('receipt.argCanceledCallout', { amount: formattedOrigAmount });
            $scope.summationTotalFormatted = $filter('currency')(0);

            $scope.lineItems.push({
                date: _paymentAgreement.dateCanceled,
                friendlyDialog: $filter('translate')('labels.paymentCanceled'),
                amountDialog: '<span>' + formattedOrigAmount + '</span>'
            });
        }
    };

    PaymentsService.fetchPaymentAgreementDetails(_paymentAgreementId).then(function(paymentAgreement) {

        if (!paymentAgreement) {
            $state.go('app.dashboard');
            return;
        }

        _paymentAgreement = $scope.paymentAgreement = paymentAgreement;

        _setupUIVariables();

        ContextHelperService.showBreadCrumbs({
            label: $filter('translate')('actions.backToArg', { properNoun: _paymentAgreement.provider.name }),
            onClick: function() {
                $state.go('app.dashboard.provider.details', { id: _paymentAgreement.provider.id });
            }
        });
    }, function() {
        $log.warn('Could not load payment with id ' + _paymentAgreementId); //user is probably not allowed to see payment
        $state.go('app.default'); //retreat!
    });

    $scope.viewEstimateDetails = function() {
        $state.go('app.dashboard.provider.details.estimate-details', { id: _paymentAgreement.provider.id, estimateId: _paymentAgreement.estimateId });
    };

    $scope.print = function() {
        try {
            $window.print();
        } catch (error) {
            var translate = $filter('translate');
            $scope.$emit('simpleModal:showPrompt', {
                header: translate('receipt.printingNotSupportedHeader'),
                subcontent: translate('receipt.printingNotSupportedContent', {
                    viewBill: translate('actions.viewBill')
                }),
                intent: 'information',
                meta: 'warning'
            });
        }
    };

});